import PendingActions from "./components/PendingActions";
import ActiveUser from "./components/ActiveUser";
import PendingUser from "./components/PendingUser";
import ActiveActions from "./components/ActiveActions";
import InactiveActions from "./components/InactiveActions";
import { checkGroup, GetRevoked, MakeHyperLink } from "./components/UserTableRenderers";
import React from 'react';

// LC-5526: surface renewal status directly in the DUC Category column across every tab, so
// DAC members don't have to open each application to tell renewals apart from initial ones.
const ducCategoryValueGetter = (params: any) => {
    const ducType = params.data?.ducType;
    return params.data?.applicationType === "Renewal" ? `${ducType} (Renewal)` : ducType;
};

export const UserGridTableDef: any = {
    pendingIso: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                minWidth: 170,
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                field: "leadRecipientName",
                headerName: "Investigator Name",
                minWidth: 200,
                flex: 2,
            },

            {
                headerName: "DUC Type",
                flex: 2,
                minWidth: 200,
                cellRenderer: checkGroup
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                minWidth: 200,
                flex: 2,
                cellRenderer: MakeHyperLink
            },
        ],
        moreInfo: PendingUser,
        rowActions: PendingActions,
        showHide: ["labPosition", "labPI", "role"],
    },
    pendingNida: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 2,
            },
            {
                field: "leadRecipientName",
                headerName: "Investigator Name",
                minWidth: 200,
                flex: 2,
            },
            {
                field: "leadRecipientEmail",
                headerName: "Investigator Email",
                minWidth: 200,
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                minWidth: 200,
                cellRenderer: checkGroup
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                minWidth: 170,
                cellRenderer: MakeHyperLink
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "dateSignedOfficial",
                headerName: "SO Signature Date",
                minWidth: 300,
                flex: 2,
            }

        ],
        moreInfo: PendingUser,
        rowActions: PendingActions,
        showHide: ["labPosition", "labPI", "role"],
    },
    pendingUser: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                minWidth: 200,
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                headerName: "DUC Type",
                minWidth: 200,
                flex: 2,
                cellRenderer: checkGroup
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                minWidth: 200,
                flex: 2,
                cellRenderer: MakeHyperLink
            },
        ],
    },
    pendingTraining: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                minWidth: 200,
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                headerName: "DUC Type",
                minWidth: 200,
                flex: 2,
                cellRenderer: checkGroup
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                minWidth: 200,
                flex: 2,
                cellRenderer: MakeHyperLink
            },
            {
                field: "leadRecipientEmail",
                headerName: "Investigator Email",
                minWidth: 250,
                flex: 2,
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "dateSignedCommittee",
                headerName: "DUC Approval Date",
                minWidth: 350,
                flex: 2,
            },
            {
                field: "revokeDuc",
                headerName: "Revoke DUC",
                filter: 'agTextColumnFilter',
                flex: 2,
                cellStyle: { textAlign: 'center' },
                minWidth: 200,
                cellRenderer: GetRevoked,
            }
        ]
    },
    active: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 200,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 200,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                minWidth: 200,
                flex: 2,
            },
            {
                field: "expiryDate",
                headerName: "DUC Expiration Date",
                filter: 'agTextColumnFilter',
                minWidth: 250,
                flex: 2,
            },
            {
                field: "leadRecipientEmail",
                headerName: "Investigator Email",
                minWidth: 200,
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                minWidth: 200,
                cellRenderer: checkGroup
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                minWidth: 200,
                cellRenderer: MakeHyperLink
            },
            {
                field: "dateTrainingComplete",
                headerName: "Training Expiration Date",
                flex: 2,
                minWidth: 250,
                // Training is valid for 1 year after completion; empty when training was never completed
                valueGetter: (params: any) => {
                    const completed = params.data?.dateTrainingComplete
                    if (!completed) return ""
                    const d = new Date(`${completed}T00:00:00Z`)
                    if (isNaN(d.getTime())) return ""
                    d.setUTCFullYear(d.getUTCFullYear() + 1)
                    return d.toISOString().slice(0, 10)
                },
            },
            {
                field: "revokeDuc",
                headerName: "Revoke DUC",
                filter: 'agTextColumnFilter',
                flex: 2,
                cellStyle: { textAlign: 'center' },
                minWidth: 200,
                cellRenderer: GetRevoked,
            },
        ],
        moreInfo: ActiveUser,
        rowActions: ActiveActions,
        showHide: ["labPosition", "labPI", "role"],
    },
    inactive: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                minWidth: 200,
                flex: 2,
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "expiryDate",
                headerName: "DUC Expiration Date",
                filter: 'agTextColumnFilter',
                minWidth: 200,
                flex: 2,
            },
        ],
        moreInfo: React.Fragment,
        rowActions: InactiveActions,
    },
    rejected: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 170,
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                minWidth: 170,
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                field: "leadRecipientEmail",
                headerName: "Investigator Email",
                minWidth: 200,
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                minWidth: 200,
                cellRenderer: checkGroup
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                minWidth: 200,
                flex: 2,
                cellRenderer: MakeHyperLink
            },
        ],
        moreInfo: React.Fragment,
    },
    pendingOwnershipTransfer: {
        columns: [
            {
                field: "originalPiName",
                headerName: "Original Investigator",
                sortable: true,
                filter: 'agTextColumnFilter',
                minWidth: 200,
                flex: 2,
            },
            {
                field: "originalPiEmail",
                headerName: "Original Investigator Email",
                minWidth: 220,
                flex: 2,
            },
            {
                field: "newPiFirstName",
                headerName: "New Investigator First Name",
                minWidth: 200,
                flex: 1.5,
            },
            {
                field: "newPiLastName",
                headerName: "New Investigator Last Name",
                minWidth: 200,
                flex: 1.5,
            },
            {
                field: "newPiEmail",
                headerName: "New Investigator Email",
                minWidth: 220,
                flex: 2,
            },
            {
                field: "reasonCategory",
                headerName: "Reason",
                minWidth: 200,
                flex: 2,
            },
            {
                field: "initiatedAt",
                headerName: "Date Initiated",
                minWidth: 200,
                flex: 1.5,
            },
            {
                field: "signingUrl",
                headerName: "New DUC Status",
                minWidth: 200,
                flex: 1.5,
                // Backend computes the same "Pending ISO approval"/"Pending NIDA approval" ("Pending
                // DAC approval" once rendered)/"View Certificate" values every other tab's DUC
                // Status column already uses, so MakeHyperLink's existing click-to-sign /
                // click-to-view-certificate behavior works here unmodified.
                valueGetter: (params: any) => params.data?.signingUrl || "Awaiting new investigator",
                cellRenderer: MakeHyperLink,
            },
        ],
        moreInfo: React.Fragment,
    },
    allUsers: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                cellRenderer: checkGroup
            },
            {
                field: "leadRecipientEmail",
                headerName: "Investigator Email",
                minWidth: 250,
                flex: 2,
            },
            {
                field: "ducType",
                headerName: "DUC Category",
                minWidth: 200,
                flex: 2,
                valueGetter: ducCategoryValueGetter,
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                cellRenderer: MakeHyperLink
            },

        ]
    },
};
